import { useEffect } from 'react'
import { useAuthStore } from '../store/authStore'

/**
 * Initialize auth state once at app startup.
 *
 * This runs before any route-specific auth checks (including Moja Biblioteka),
 * so a user with a valid Flask session cookie is recognised immediately.
 */
export default function AuthInitializer({ children }) {
  const fetchUser = useAuthStore((state) => state.fetchUser)

  useEffect(() => {
    fetchUser()
  }, [fetchUser])

  return children
}
